import $ from "$";
import Overlay from "overlay";
import evt from "event";
import ua from "ua";
import sensors from "sensors";

var $body = $("body");

class PopOverlay {
  constructor(
    $popContainer,
    config = {
      needOverlay: true,
      needNewOverlay: false,
    }
  ) {
    config = this.config = config || {};
    var $overlay = $(".overlay");
    if (!$overlay.get().length || config.needNewOverlay) {
      this.overlay = new Overlay();
      this.$overlay = this.overlay.$el;
    } else {
      this.overlay = new Overlay($overlay.first());
      this.$overlay = $overlay.first();
    }

    var zIndexOverlay = config.zIndexOverlay || "10";
    this.$overlay.css("zIndex", zIndexOverlay);
    this.$popContainer = $popContainer;
    this.$overlay.hide();

    if (!config.doNotAppend) {
      if (!config.container) {
        $body.append($popContainer);
      } else {
        config.container.append($popContainer);
      }
    }

    if (config.hide) {
      config.hide();
    } else {
      $popContainer.hide();
    }

    var $close = config.$close || $popContainer.find(".pop-close");

    $close.click((e) => {
      e.stopPropagation();
      sensors.track("CloseHomepagePopupClick");
      this.hide();
    });

    this.$overlay.on("tap", () => {
      this.hide();
    });
    this.$overlay.on("touchend", () => {
      this.hide();
    });
  }
  show() {
    this.$overlay.show();
    if (this.config.show) {
      this.config.show();
    } else {
      this.$popContainer.show();
    }

    if (this.config.needOverlay) {
      this.overlay.show();
    }

    if (ua.isMobile()) {
      this.$overlay.on("touchmove", function(e) {
        e.preventDefault();
      });
    } else {
      $body.addClass("disable-scroll");
    }

    this.shown = true;
  }
  hide() {
    this.$overlay.hide();

    if (this.config.hide) {
      this.config.hide();
    } else {
      this.$popContainer.hide();
    }

    if (!ua.isMobile()) {
      $body.removeClass("disable-scroll");
    }

    this.emit("hide");

    this.shown = false;
  }
  toggle() {
    if (this.shown) {
      this.hide();
    } else {
      this.show();
    }
  }
}

evt.mixin(PopOverlay);

module.exports = PopOverlay;



// WEBPACK FOOTER //
// ./src/mods/PopOverlay.js